import { useNonConflictingTheme } from "src/lib/emotion/use-non-conflicting-theme.ts";
import { ThemeProvider } from "@emotion/react";
import { DataGridOverlay } from "./DataGridOverlay.tsx";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import DatabaseViewedThroughLupe from "src/assets/illustrations/database_viewed_through_lupe.svg?react";
import { H4 } from "src/components/HeadingV2/HeadingV2.tsx";
import { ButtonV2 } from "src/components/ButtonV2/ButtonV2.tsx";
import * as styles from "./DataGridEnableDataLoadingOverlay.style.ts";

export const DataGridEnableDataLoadingOverlay = ({
  onEnable = () => {},
}: {
  onEnable?: () => void;
}) => {
  const theme = useNonConflictingTheme();
  const { t } = useTranslation(TranslationNamespaceEnum.DataGridComponent);

  return (
    <ThemeProvider theme={theme}>
      <DataGridOverlay>
        <H4 css={styles.title}>{t("showAllOverlay.title")}</H4>
        <DatabaseViewedThroughLupe css={styles.image} />
        <ButtonV2 variant="filled" size={"sm"} skin="info" onClick={onEnable}>
          {t("showAllOverlay.action")}
        </ButtonV2>
      </DataGridOverlay>
    </ThemeProvider>
  );
};
